import React from 'react';
import Logo from '../Logo/Logo';

export default function AuthPage({ title = '', children, error = '' }) {
  return (
    <div className="flex min-h-full flex-col justify-center px-6 py-12 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-sm">
        <Logo />
        <h1 className="mt-10 text-center text-2xl/9 font-bold tracking-tight text-white">{title}</h1>
      </div>

      <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        {error && <div role="alert" className="mb-6 text-red-600 text-sm">{error}</div>}
        {children}
      </div>
    </div>
  )
}
